import * as els from './halfPageManagerElements';

// Helper funkce pro detekci typu stránky
export const isArticleDetailPage = (): boolean => {
    return Boolean(els.articleMainContent && els.articleSecondaryContent);
};
